import type { PgOrderEntity } from '@wolfejs/ms-api-js/src/types/orders';
import isEmpty from 'lodash/isEmpty';
import { defaultOrderHistoryData } from './constants';

export const mapOrderHistoryData = (orders?: PgOrderEntity[]) => {
  if (isEmpty(orders)) return [];

  return orders?.map(order => ({
    ...defaultOrderHistoryData,
    id: order.id,
    orderId: order.id,
    itemsCount: order.items_count,
    datePlaced: order.date_created,
    price: order.total,
    status: order.status,
  }));
};
